export const LEADERBOARD_TOP_PATH = "leaderboard/top";
export const LEADERBOARD_SUBMISSIONS_PATH = "leaderboard/submissions";
export const LEADERBOARD_RATE_LIMIT_PATH = "leaderboard/rateLimit";

/** @deprecated Legacy path. Current clients do not read RTDB; shipped builds may still read `leaderboard/top`. */
export const LEADERBOARD_SCORES_PATH = "leaderboard/scores";

export const LEADERBOARD_TOP_SIZE = 10;
export const LEADERBOARD_MAX_SCORE = 100000000;
export const LEADERBOARD_DEFAULT_LIMIT = 10;
export const LEADERBOARD_SUBMIT_REPLAY_MS = 5 * 60 * 1000;
export const LEADERBOARD_SUBMIT_RATE_LIMIT_MS = 10 * 1000;

/** Shared with Cloud Functions — keep in sync with functions/src/leaderboard/constants.ts */
export const LEADERBOARD_SUBMIT_SECRET = "cm7Lb3xQp2vRn4wHt8jKb6sFd9c";
